module.exports = __webpack_public_path__ + "static/media/Quicksand_Light_Oblique.14e71c51.otf";